/**
 * A React functional component that renders a 403 Forbidden error message.
 * @returns {JSX.Element} A JSX element containing the error message.
 */
function NotFound() {
  return (
    <div style={{ textAlign: "center", marginTop: "20%" }}>
      <h1>404</h1>
      <h2>Not Found</h2>
    </div>
  );
}

export default NotFound;
